var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardIcon = function SvgCreditCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "creditCardIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-2 -2)",
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h36v36H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "creditCardIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "creditCardIcon_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(34.49999 24.50002 -23.17567 32.6351 -4.5 1.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#4D555B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "creditCardIcon_svg__d",
    x1: 23.319,
    y1: 10.082,
    x2: 8.662,
    y2: 26.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D555B",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#4D555B",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#26292B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25282A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#creditCardIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#creditCardIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    rx: 4,
    width: 28,
    height: 20,
    fill: "url(#creditCardIcon_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.98 9.61C28.3 11.75 25.76 13.5 22 13.5c-8.08 0-10.52 3.61-10.94 10.49-.05.82-.45 1.55-1.07 2.01H6c-2.21 0-4-1.8-4-4V10c0-2.21 1.79-4 4-4h20c2.07 0 3.78 1.58 3.98 3.61Z",
    fill: "url(#creditCardIcon_svg__d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 11.5,
    r: 2.5,
    fill: "#727B82",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 18,
    rx: 2.5,
    width: 10,
    height: 5,
    fill: "#727B82",
    fillOpacity: 0.35
  })))));
};
export { SvgCreditCardIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIuMDAwMDAwIiBoZWlnaHQ9IjMyLjAwMDAwMCIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KCTxkZXNjPgoJCQlDcmVhdGVkIHdpdGggUGl4c28uCgk8L2Rlc2M+Cgk8ZGVmcz4KCQk8Y2xpcFBhdGggaWQ9ImNsaXA2M183MTYwNiI+CgkJCTxyZWN0IGlkPSIgMzYgTXVsdGljb2xvciAvIENhcmQgLyBkc19tY18zNl9jcmVkaXRfc2JlcmNhcmQiIHdpZHRoPSIzNi4wMDAwMDAiIGhlaWdodD0iMzYuMDAwMDAwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4wMDAwMDAgLTIuMDAwMDAwKSIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMCIvPgoJCTwvY2xpcFBhdGg+CgkJPGNsaXBQYXRoIGlkPSJjbGlwNjNfNzE2MDUiPgoJCQk8cmVjdCBpZD0iRnJhbWUgMjEzMTMyNzg3MCIgd2lkdGg9IjMyLjAwMDAwMCIgaGVpZ2h0PSIzMi4wMDAwMDAiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAiLz4KCQk8L2NsaXBQYXRoPgoJCTxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnRfcmFkaWFsXzg1XzE3NzVfMCIgY3g9IjAuMDAwMDAwIiBjeT0iMC4wMDAwMDAiIHI9IjEuMDAwMDAwIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgtNC40OTk5OSAxLjUpIHJvdGF0ZSgzNS4zODAzKSBzY2FsZSg0Mi4zMTQzIDQwLjAyNykiPgoJCQk8c3RvcCBvZmZzZXQ9IjAuMTExMTgwIiBzdG9wLWNvbG9yPSIjMTIxMjEyIi8+CgkJCTxzdG9wIG9mZnNldD0iMC41NzA4OTEiIHN0b3AtY29sb3I9IiMwRTBFMEUiLz4KCQkJPHN0b3Agb2Zmc2V0PSIwLjk1NjAxMCIgc3RvcC1jb2xvcj0iIzRENTU1QiIvPgoJCTwvcmFkaWFsR3JhZGllbnQ+CgkJPGxpbmVhckdyYWRpZW50IGlkPSJwYWludF9saW5lYXJfODVfMTc3Nl8wIiB4MT0iMjMuMzE5MDU0IiB5MT0iMTAuMDgxNjM1IiB4Mj0iOC42NjIyMzciIHkyPSIyNi40MDgxODQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KCQkJPHN0b3Agc3RvcC1jb2xvcj0iIzRENTU1QiIgc3RvcC1vcGFjaXR5PSIwLjkwMTk2MSIvPgoJCQk8c3RvcCBvZmZzZXQ9IjAuMzMzOTUyIiBzdG9wLWNvbG9yPSIjNEQ1NTVCIiBzdG9wLW9wYWNpdHk9IjAuNzAxOTYxIi8+CgkJCTxzdG9wIG9mZnNldD0iMC42ODg1OTQiIHN0b3AtY29sb3I9IiMyNjI5MkIiLz4KCQkJPHN0b3Agb2Zmc2V0PSIxLjAwMDAwMCIgc3RvcC1jb2xvcj0iIzI1MjgyQSIvPgoJCTwvbGluZWFyR3JhZGllbnQ+Cgk8L2RlZnM+Cgk8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDYzXzcxNjA1KSI+CgkJPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXA2M183MTYwNikiPgoJCQk8cmVjdCBpZD0iYmciIHg9IjIuMDAwMDAwIiB5PSI2LjAwMDAwMCIgcng9IjQuMDAwMDAwIiB3aWR0aD0iMjguMDAwMDAwIiBoZWlnaHQ9IjIwLjAwMDAwMCIgZmlsbD0idXJsKCNwYWludF9yYWRpYWxfODVfMTc3NV8wKSIgZmlsbC1vcGFjaXR5PSIxLjAwMDAwMCIvPgoJCQk8cGF0aCBpZD0ic2hhcGUiIGQ9Ik0yOS45OCA5LjYxQzI4LjMgMTEuNzUgMjUuNzYgMTMuNSAyMiAxMy41QzEzLjkyIDEzLjUgMTEuNDggMTcuMTEgMTEuMDYgMjMuOTlDMTEuMDEgMjQuODEgMTAuNjEgMjUuNTQgOS45OSAyNkw2IDI2QzMuNzkgMjYgMiAyNC4yIDIgMjJMMiAxMEMyIDcuNzkgMy43OSA2IDYgNkwyNiA2QzI4LjA3IDYgMjkuNzggNy41OCAyOS45OCA5LjYxWiIgZmlsbD0idXJsKCNwYWludF9saW5lYXJfODVfMTc3Nl8wKSIgZmlsbC1vcGFjaXR5PSIxLjAwMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIi8+CgkJCTxnIG9wYWNpdHk9IjAuODAwMDAwIj4KCQkJCTxjaXJjbGUgaWQ9ImxvZ28iIGN4PSI3LjUwMDAwMCIgY3k9IjExLjUwMDAwMCIgcj0iMi41MDAwMDAiIGZpbGw9IiM3MjdCODIiIGZpbGwtb3BhY2l0eT0iMS4wMDAwMDAiLz4KCQkJPC9nPgoJCQk8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIxNy4wMDAwMDAiIHk9IjE4LjAwMDAwMCIgcng9IjIuNTAwMDAwIiB3aWR0aD0iMTAuMDAwMDAwIiBoZWlnaHQ9IjUuMDAwMDAwIiBmaWxsPSIjNzI3QjgyIiBmaWxsLW9wYWNpdHk9IjAuMzUwMDAwIi8+CgkJPC9nPgoJPC9nPgo8L3N2Zz4K";